import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { setLicense } from './license';

export function initAgGrid() {
  // Since v33, features are only available once their module is registered. Register everything
  // (community + enterprise), which matches what importing ag-grid-enterprise did in v31.
  ModuleRegistry.registerModules([AllEnterpriseModule]);
  setLicense();
}
